import React from 'react';
import { Table } from 'antd';

const CustomerTable = ({ data = [] }) => {
  const columns = [
    {
      title: 'STT',
      dataIndex: 'index',
      width: 80,
      align: 'center',
      fixed: true,
    },
    {
      title: 'Khách hàng',
      dataIndex: 'customerName',
      align: 'center',
    },
    {
      title: 'Booking',
      dataIndex: 'countBooking',
      align: 'center',
    },
    {
      title: 'Bill',
      dataIndex: 'countBill',
      align: 'center',
    },
    {
      title: 'Tổng Sản Lượng (Theo Cont)',
      dataIndex: 'totalCont',
      align: 'center',
    },
  ];
  return (
    <div>
      <Table
        bordered
        size='small'
        loading={false}
        columns={columns}
        dataSource={data}
        rowKey='id'
        scroll={{
          x: '100%',
          y: 600,
        }}
        pagination={false}
      />
    </div>
  );
};

export { CustomerTable };
